import {
	CogIcon,
	CurrencyDollarIcon,
	MusicNoteIcon,
	ShieldCheckIcon,
	SupportIcon,
	ChartBarIcon
} from '@heroicons/react/outline';
import Fade from 'react-reveal/Fade';

const features = [
	{
		name: 'Finance Reports',
		description: 'We provide you a dashboard so you can keep on top of your earnings.',
		icon: CurrencyDollarIcon
	},
	{
		name: 'Takedown',
		description: 'We help content creators takedown videos they do not want uploaded online.',
		icon: ShieldCheckIcon
	},
	{
		name: 'Full Service',
		description: 'From identification to claiming to monetization, we take care of everything.',
		icon: CogIcon
	},
	{
		name: 'Data & Analytics',
		description:
			'Download numbers and listener demographic data from your personal dashboard to help you plan the best next steps for your career.',
		icon: ChartBarIcon
	},
	{
		name: 'Hands-On Support',
		description:
			'We love working closely with our creators who are serious about growth. No other network is more hands-on and responsive than Noisely.',
		icon: SupportIcon
	},
	{
		name: 'Music Distribution',
		description:
			'We offer the assistance and the right tools to monetize and optimally distribute your music online as well as track listeners on YouTube.',
		icon: MusicNoteIcon
	}
];

export default function Services() {
	return (
		<div className="relative bg-white py-16 sm:py-24 lg:py-32">
			<div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
				<Fade up>
					<p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
						Our services help you <span className="text-rose-500">protect</span> and{' '}
						<span className="text-rose-500">monetize</span> your content online.
					</p>
					<p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
						Noisely aims to help content owners gain control of their intellectual property and ensure you
						are maximising on your digital footprint.
					</p>
				</Fade>
				<div className="mt-12">
					<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
						{features.map((feature) => (
							<Fade up>
								<div key={feature.name} className="pt-6">
									<div className="flow-root bg-gray-50 rounded-lg px-6 pb-8">
										<div className="-mt-6">
											<div>
												<span className="inline-flex items-center justify-center p-3 bg-gradient-to-r from-rose-500 to-rose-600 rounded-md shadow-lg">
													<feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
												</span>
											</div>
											<h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">
												{feature.name}
											</h3>
											<p className="mt-5 text-base text-gray-500">{feature.description}</p>
										</div>
									</div>
								</div>
							</Fade>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
